import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { EXPERIENCES } from "../mock";
import { Reveal } from "../hooks/useReveal";
import { useToast } from "../hooks/use-toast";

const Experiences = () => {
  const { toast } = useToast();

  const reserve = (title) => {
    toast({
      title: "Trip request noted — island time!",
      description: `We'll reach out about your "${title}" adventure. Scroll down to send your enquiry.`,
    });
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="experiences" className="bg-[#EFE9DD] py-24 md:py-32 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <Reveal className="flex items-center gap-4 mb-6">
          <span className="h-px w-10 bg-[#D2703F]" />
          <span className="eyebrow text-[#B85A2C]">Experiences</span>
        </Reveal>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-14">
          <Reveal>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-[3.4rem] leading-tight text-[#26302A]">
              Choose Your SIQ Adventure
            </h2>
            <p className="mt-6 text-[#26302A]/70 text-lg leading-relaxed max-w-3xl">
              Chase waterfalls, discover beautiful beaches, explore winding coastal roads, taste local food, meet the people who make Siquijor special, or let us take care of the itinerary while you simply enjoy the ride. Whether you're searching for things to do in Siquijor, planning your first Siquijor island tour, or looking for a more local way to explore beyond the usual tourist trail, there's a SIQ Adventure waiting for you.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {EXPERIENCES.map((exp, i) => (
            <Reveal key={exp.id} delay={(i % 3) * 100}>
              <article className="group h-full flex flex-col bg-white rounded-2xl overflow-hidden border border-[#26302A]/8 hover:shadow-2xl hover:shadow-[#26302A]/10 transition-all duration-500 hover:-translate-y-2">
                <div className="relative h-56 overflow-hidden bg-[#0e1a1e]">
                  {exp.fit === "contain" && (
                    <img
                      src={exp.image}
                      alt=""
                      aria-hidden="true"
                      className="absolute inset-0 w-full h-full object-cover blur-md scale-125 opacity-70"
                    />
                  )}
                  <img src={exp.image} alt={exp.title} className={`relative w-full h-full transition-transform duration-700 ${exp.fit === "contain" ? "object-contain group-hover:scale-105" : "object-cover group-hover:scale-110"}`} />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                  {exp.level && (
                    <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-[#EFE9DD]/95 text-[#26302A] text-xs font-medium tracking-wide">
                      {exp.level}
                    </span>
                  )}
                </div>
                <div className="flex flex-col flex-1 p-7">
                  <h3 className="font-serif-display text-2xl md:text-[1.7rem] text-[#26302A] leading-tight">
                    {exp.title}
                  </h3>

                  <ul className="mt-5 space-y-3 flex-1">
                    {exp.features.map((f) => (
                      <li key={f} className="flex items-start gap-2.5 text-[#26302A]/75 text-[15px]">
                        <Check className="w-4 h-4 text-[#D2703F] shrink-0 mt-1" />
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="mt-6 font-serif-display text-3xl text-[#B85A2C] leading-none">
                    {exp.price}
                  </div>

                  <button
                    onClick={() => reserve(exp.title)}
                    className="group/btn mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-[#D2703F] hover:bg-[#B85A2C] text-white font-medium py-3.5 transition-all duration-300 hover:-translate-y-0.5"
                  >
                    {exp.cta}
                    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                  </button>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experiences;
